export default {
  label: "fluid",
  onValue : "container-fluid",
  offValue : "container"
}


// WEBPACK FOOTER //
// ./src/shell/schemas/grid/fluid.js